import { Component, Input, OnInit } from "@angular/core";
import { AccountService } from "../../../../platform-pages/src/lib/pages/home-admin/home-admin-data/account.service";
import { AgreementTerms } from "../../../../platform-pages/src/lib/api/messages/messages.types";
import { take } from "rxjs";

@Component({
  selector: "mh-account-hirings",
  templateUrl: "./account-hirings.component.html",
  styleUrls: ["./account-hirings.component.less"],
})
export class AccountHiringsComponent implements OnInit {
  @Input() talentId!: string;
  hirings: AgreementTerms[] = [];

  constructor(private accountService: AccountService) {}

  ngOnInit() {
    this.loadHirings();
  }

  loadHirings() {
    this.accountService
      .getHiringTermsForCompletedHirings(this.talentId)
      .pipe(take(1))
      .subscribe((hirings) => {
        this.hirings = hirings;
      });
  }
}
